// extracted by mini-css-extract-plugin
export default {"avatar--rounded":"avatar--rounded--34MEU","avatar--bordered":"avatar--bordered--1mECy","avatar--md":"avatar--md--1hOre"};
    if(module.hot) {
      // 1747648162452
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  